import React, { useEffect, useState } from "react";
import { useStyles } from "./style";
import { useAppSelector } from "src/app-redux/hooks";
import { vehicleComparisonData } from "src/app-redux/hq-dashboard/hqDashboardSlice";

export function VehicleLevel3ComparisonTable(): React.ReactElement {
  const classes = useStyles();
  const comparisonArr = useAppSelector(vehicleComparisonData);
  // const comparisonArr = [
  //   ["BT", "ATT", "EMPTY", "EXPORT", "IMPORT", "VEHICLE"],
  //   ["CH", "0", "0", "0", "0", "0"],
  //   ["KRBT", "0", "1", "2", "0", "0"],
  //   ["KRBT", "3", "0", "4", "5", "0"],
  //   ["KRBT", "0", "6", "7", "8", "9"],
  //   ["KRBT", "2", "3", "4", "5", "6"],
  // ];
  const [totalArr, setTotalArr] = useState<number[]>([]);

  useEffect(() => {
    if (comparisonArr?.length) {
      const totalRowArr: any = [];
      comparisonArr[0].forEach((item: any, arrIndex: number) => {
        let sum = 0;
        if (arrIndex != 0) {
          comparisonArr.forEach((arr: any, subArrIndex: number) => {
            if (subArrIndex != 0) sum = sum + Number(arr[arrIndex]);
          });
          totalRowArr.push(sum);
        }
      });
      totalRowArr.push(totalRowArr.reduce((a: number, b: number) => a + b, 0));
      setTotalArr(totalRowArr);
    }
  }, [comparisonArr]);

  const getSum = (total: any, num: any) => {
    return Number(num) ? total + Math.round(num) : total;
  };

  return (
    <>
      {comparisonArr.length ? (
        <table className={classes.blueTable}>
          <thead className={classes.tHead}>
            <tr>
              <th className={`${classes.tableCells} ${classes.tHead}`} rowSpan={2}>
                BT
              </th>
              <th
                className={`${classes.tableCells} ${classes.tHead}`}
                colSpan={comparisonArr[0].length - 1}
              >
                VEHICLES
              </th>
              <th className={`${classes.tableCells} ${classes.tHead}`} rowSpan={2}>
                TOTAL
              </th>
            </tr>
            <tr>
              {comparisonArr[0].map((name: any, index: any) => {
                return index == 0 ? (
                  <></>
                ) : (
                  <th
                    key={name + index}
                    className={`${classes.tableCells} ${classes.tHead} ${classes.nthChild}`}
                  >
                    {name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {comparisonArr.map((row, indexRow) => {
              return indexRow == 0 ? (
                <></>
              ) : (
                <tr key={indexRow} className={indexRow % 2 == 0 ? classes.nthChild : ""}>
                  {row.map((data: any, indexData: number) => {
                    return (
                      <td
                        key={data + indexData}
                        className={`${classes.tableCells} ${classes.bodytd} ${classes.bodytdBT}`}
                      >
                        {data}
                      </td>
                    );
                  })}
                  <td className={`${classes.tableCells} ${classes.bodytd} ${classes.bodytdBT}`}>
                    {row.reduce(getSum, 0)}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td className={`${classes.tableCells} ${classes.bodytd}`}>TOTAL</td>
              {totalArr.map((val: number, index: number) => {
                return (
                  <td
                    key={val.toString() + index}
                    className={`${classes.tableCells} ${classes.bodytd}`}
                  >
                    {val}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      ) : (
        <div>No data found</div>
      )}
    </>
  );
}
